import React from 'react'
import Checkbox from '@material-ui/core/Checkbox'
import TextField from '@material-ui/core/TextField'
import Auto from '@material-ui/lab/Autocomplete'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import styles from './styles'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

export type DataType = {
  id: string
  name: string
}

type Props = {
  title: string
  placeholderText: string
  data: DataType[]
  value: DataType[] | DataType | undefined
  id: string
  multiple?: boolean
  onChange: (selected: DataType[] | DataType | undefined) => void
}

const Autocomplete = function ({
  title,
  placeholderText,
  data,
  value,
  id,
  onChange,
  multiple,
}: Props) {
  return (
    <Auto
      value={value}
      multiple={multiple}
      onChange={(_event, selected) => onChange(selected as DataType[])}
      id={id}
      getOptionSelected={(option, currValue) => option.id === currValue.id}
      options={data}
      disableCloseOnSelect={multiple}
      getOptionLabel={(option: DataType) => option.name}
      renderOption={(option, {selected}) => (
        <React.Fragment>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={styles.checkbox}
            checked={selected}
          />
          {option.name}
        </React.Fragment>
      )}
      style={styles.autocomplete}
      renderInput={(params) => (
        <TextField {...params} variant="outlined" label={title} placeholder={placeholderText} />
      )}
    />
  )
}
export default Autocomplete
